import GlobalLanguageSelection from './GlobalLanguageSelection';

export default GlobalLanguageSelection;
